export default __webpack_public_path__ + "static/media/1inch.2d0face7.png";